"use client";

import { c as _c } from "react/compiler-runtime";
import { type FragmentOfShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import type { Route } from "next";
import { useParams, useSearchParams } from "next/navigation";
import { RefineByListItem } from "#/components/molecules/search-refinements/refine-by-list-item";
import { Collection_Fragment } from "#/graphql/shopify-storefront/fragments";
export function RefineByFilterByPathItem(t0) {
  const $ = _c(16);
  const {
    collectionMasked
  } = t0;
  let t1;
  if ($[0] !== collectionMasked) {
    t1 = readFragmentShopifyStorefront(Collection_Fragment, collectionMasked);
    $[0] = collectionMasked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const params = useParams();
  const currentSearchParams = useSearchParams();
  let T0;
  let t2;
  let t3;
  let t4;
  let title;
  if ($[2] !== collection.handle || $[3] !== collection.title || $[4] !== currentSearchParams || $[5] !== params?.collection) {
    const searchParams = new URLSearchParams(currentSearchParams);
    title = collection.title;
    const active = params?.collection === collection.handle;
    searchParams.delete("q");
    T0 = RefineByListItem;
    t4 = active;
    t2 = collection.handle;
    t3 = searchParams.toString();
    $[2] = collection.handle;
    $[3] = collection.title;
    $[4] = currentSearchParams;
    $[5] = params?.collection;
    $[6] = T0;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = title;
  } else {
    T0 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    title = $[10];
  }
  const t5 = `/search/${t2}?${t3}` as Route;
  let t6;
  if ($[11] !== T0 || $[12] !== t4 || $[13] !== t5 || $[14] !== title) {
    t6 = <T0 active={t4} href={t5} title={title} />;
    $[11] = T0;
    $[12] = t4;
    $[13] = t5;
    $[14] = title;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}